import AddressAutocompleteContainer from './AddressAutocompleteContainer';

export default AddressAutocompleteContainer;



// WEBPACK FOOTER //
// ./src/components/AddressAutocompleteContainer/index.js